import { useContext } from 'react';
import GruserContext from '../context/GruserContext/GruserContext';
import { generateGruserObjectId } from '../redux/helpers';
export const useGruser = ()=>{
    const gruser = useContext(GruserContext);
    return gruser;
};
export const useGruserObjectId = ()=>{
    const gruser = useGruser();
    return gruser && generateGruserObjectId(gruser);
};
export default useGruser;
